var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center mt-5"},[_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){return _vm.downloadFile()}}},[_vm._v(" Download ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }